import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        {
          staticClass:
            "d-flex flex-wrap align-center justify-space-between mb-4",
        },
        [
          _vm._m(0),
          _c(
            "div",
            { staticClass: "d-flex flex-wrap mt-2 mt-sm-0" },
            [
              _c(
                VBtn,
                {
                  staticClass: "mr-2 mb-2 mb-sm-0",
                  attrs: { text: "", loading: _vm.loading },
                  on: { click: _vm.loadApiKeys },
                },
                [_vm._v(" Refresh ")]
              ),
              _c(
                VBtn,
                {
                  staticClass: "mb-2 mb-sm-0",
                  attrs: { color: "primary" },
                  on: { click: _vm.openCreateDialog },
                },
                [_vm._v(" New API Key ")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        VAlert,
        {
          staticClass: "mb-4",
          attrs: { dense: "", outlined: "", type: "info" },
        },
        [
          _vm._v(" Browser requests using "),
          _c("code", [_vm._v("X-API-Key")]),
          _vm._v(
            " are checked against the allowed origins on that key. Leave origins empty for server-to-server usage only. "
          ),
        ]
      ),
      _c(VProgressLinear, {
        staticClass: "mb-4",
        attrs: { color: "primary", indeterminate: "", active: _vm.loading },
      }),
      _c(
        VCard,
        [
          _c(VDataTable, {
            staticClass: "api-key-table",
            attrs: {
              headers: _vm.headers,
              items: _vm.apiKeys,
              loading: _vm.loading,
              "sort-by": "createdAt",
              "sort-desc": true,
            },
            scopedSlots: _vm._u([
              {
                key: "item.isActive",
                fn: function ({ item }) {
                  return [
                    _c(
                      VChip,
                      {
                        attrs: {
                          "x-small": "",
                          color: item.isActive
                            ? "green lighten-4"
                            : "grey lighten-3",
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(item.isActive ? "Active" : "Inactive") +
                            " "
                        ),
                      ]
                    ),
                  ]
                },
              },
              {
                key: "item.allowedOrigins",
                fn: function ({ item }) {
                  return [
                    item.allowedOrigins && item.allowedOrigins.length
                      ? _c(
                          "div",
                          { staticClass: "py-2" },
                          _vm._l(item.allowedOrigins, function (origin) {
                            return _c(
                              VChip,
                              {
                                key: `${item.id}-${origin}`,
                                staticClass: "mr-1 mb-1",
                                attrs: { "x-small": "" },
                              },
                              [_vm._v(" " + _vm._s(origin) + " ")]
                            )
                          }),
                          1
                        )
                      : _c(
                          "span",
                          {
                            staticClass:
                              "text-caption grey--text text--darken-1",
                          },
                          [_vm._v(" Server-to-server only ")]
                        ),
                  ]
                },
              },
              {
                key: "item.lastUsedAt",
                fn: function ({ item }) {
                  return [
                    item.lastUsedAt
                      ? _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("formatDateTimeYear")(item.lastUsedAt)
                            )
                          ),
                        ])
                      : _c(
                          "span",
                          {
                            staticClass:
                              "text-caption grey--text text--darken-1",
                          },
                          [_vm._v("Never")]
                        ),
                  ]
                },
              },
              {
                key: "item.expiresAt",
                fn: function ({ item }) {
                  return [
                    item.expiresAt
                      ? _c("span", [
                          _vm._v(
                            _vm._s(_vm._f("formatDateTimeYear")(item.expiresAt))
                          ),
                        ])
                      : _c(
                          "span",
                          {
                            staticClass:
                              "text-caption grey--text text--darken-1",
                          },
                          [_vm._v("Never")]
                        ),
                  ]
                },
              },
              {
                key: "item.createdAt",
                fn: function ({ item }) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(_vm._f("formatDateTimeYear")(item.createdAt)) +
                        " "
                    ),
                  ]
                },
              },
              {
                key: "item.actions",
                fn: function ({ item }) {
                  return [
                    _c(
                      "div",
                      { staticClass: "text-no-wrap" },
                      [
                        _c(
                          VBtn,
                          {
                            attrs: {
                              icon: "",
                              small: "",
                              title: "Edit API key",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.openEditDialog(item)
                              },
                            },
                          },
                          [
                            _c(VIcon, { attrs: { small: "" } }, [
                              _vm._v("mdi-pencil"),
                            ]),
                          ],
                          1
                        ),
                        _c(
                          VBtn,
                          {
                            attrs: {
                              icon: "",
                              small: "",
                              title: "Deactivate API key",
                              disabled: !item.isActive,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.deactivateKey(item)
                              },
                            },
                          },
                          [
                            _c(VIcon, { attrs: { small: "" } }, [
                              _vm._v("mdi-cancel"),
                            ]),
                          ],
                          1
                        ),
                        _c(
                          VBtn,
                          {
                            attrs: {
                              icon: "",
                              small: "",
                              title: "Delete API key",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.deleteKey(item)
                              },
                            },
                          },
                          [
                            _c(
                              VIcon,
                              { attrs: { small: "", color: "red darken-1" } },
                              [_vm._v("mdi-delete")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        VDialog,
        {
          attrs: { "max-width": "720" },
          model: {
            value: _vm.editorDialog,
            callback: function ($$v) {
              _vm.editorDialog = $$v
            },
            expression: "editorDialog",
          },
        },
        [
          _c(
            VCard,
            [
              _c(VCardTitle, [
                _vm._v(
                  _vm._s(_vm.isEditing ? "Edit API Key" : "Create API Key")
                ),
              ]),
              _c(
                VCardText,
                [
                  _c(
                    VForm,
                    {
                      ref: "editorForm",
                      attrs: { "lazy-validation": "" },
                      model: {
                        value: _vm.formValid,
                        callback: function ($$v) {
                          _vm.formValid = $$v
                        },
                        expression: "formValid",
                      },
                    },
                    [
                      _c(VTextField, {
                        attrs: {
                          label: "Key Name",
                          rules: _vm.keyNameRules,
                          counter: "100",
                          required: "",
                        },
                        model: {
                          value: _vm.form.keyName,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "keyName", $$v)
                          },
                          expression: "form.keyName",
                        },
                      }),
                      _c(VTextarea, {
                        attrs: {
                          label: "Description",
                          rows: "2",
                          "auto-grow": "",
                          counter: "500",
                        },
                        model: {
                          value: _vm.form.description,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "description", $$v)
                          },
                          expression: "form.description",
                        },
                      }),
                      _c(VTextField, {
                        attrs: {
                          label: "Expires At",
                          type: "datetime-local",
                          hint: "Optional",
                          "persistent-hint": "",
                        },
                        model: {
                          value: _vm.form.expiresAt,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "expiresAt", $$v)
                          },
                          expression: "form.expiresAt",
                        },
                      }),
                      _c(VCombobox, {
                        attrs: {
                          label: "Allowed Browser Origins (CORS)",
                          multiple: "",
                          chips: "",
                          "small-chips": "",
                          "deletable-chips": "",
                          clearable: "",
                          "hide-selected": "",
                          "persistent-hint": "",
                          hint: "Enter full origins (e.g. https://factory.bergsoemetals.com, http://localhost:9083). Leave empty for server-to-server only (no browser restriction).",
                        },
                        model: {
                          value: _vm.form.allowedOrigins,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "allowedOrigins", $$v)
                          },
                          expression: "form.allowedOrigins",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                VCardActions,
                [
                  _c(VSpacer),
                  _c(
                    VBtn,
                    { attrs: { text: "" }, on: { click: _vm.closeEditor } },
                    [_vm._v("Cancel")]
                  ),
                  _c(
                    VBtn,
                    {
                      attrs: { color: "primary", loading: _vm.saving },
                      on: { click: _vm.saveApiKey },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.isEditing ? "Save Changes" : "Create Key"
                          ) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        VDialog,
        {
          attrs: { "max-width": "760" },
          model: {
            value: _vm.createdKeyDialog,
            callback: function ($$v) {
              _vm.createdKeyDialog = $$v
            },
            expression: "createdKeyDialog",
          },
        },
        [
          _c(
            VCard,
            [
              _c(VCardTitle, [_vm._v("Copy API Key Now")]),
              _c(
                VCardText,
                [
                  _c("div", { staticClass: "mb-3" }, [
                    _vm._v(
                      " This is the only time the full API key will be shown. "
                    ),
                  ]),
                  _c(VTextField, {
                    attrs: {
                      value: _vm.createdKey.apiKey,
                      label: "API Key",
                      readonly: "",
                      "append-icon": "mdi-content-copy",
                    },
                    on: { "click:append": _vm.copyCreatedKey },
                  }),
                  _c(
                    "div",
                    { staticClass: "text-caption grey--text text--darken-1" },
                    [
                      _vm._v(
                        " Key: " + _vm._s(_vm.createdKey.keyName || "n/a") + " "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                VCardActions,
                [
                  _c(VSpacer),
                  _c(
                    VBtn,
                    { attrs: { text: "" }, on: { click: _vm.copyCreatedKey } },
                    [_vm._v("Copy")]
                  ),
                  _c(
                    VBtn,
                    {
                      attrs: { color: "primary" },
                      on: { click: _vm.closeCreatedKeyDialog },
                    },
                    [_vm._v("Done")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "mr-4" }, [
      _c("div", { staticClass: "text-h5" }, [_vm._v("API Settings")]),
      _c("div", { staticClass: "text-body-2 grey--text text--darken-1" }, [
        _vm._v(
          " Create API keys and control which browser origins may use them. "
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }